import type {RouterConfig} from '@nuxt/schema'
import {isShopRoutePath, mainSiteSections, mainSiteShopPath, SHOP_MAIN_SITE_ROUTE, stripShopPrefix} from '~/utils/shopHost'

export default <RouterConfig>{
    routes: (routes) => {
        const {isShopHost, mountOnMainSite} = useShopHost()

        if (!isShopHost.value) {
            if (!mountOnMainSite.value) {
                return routes.filter((route) => !isShopRoutePath(route.path))
            }

            return routes.flatMap((route) => {
                if (!isShopRoutePath(route.path)) {
                    return [route]
                }

                const path = mainSiteShopPath(route.path)

                return path ? [{...route, path}] : []
            })
        }

        const shopRoutes = routes
            .filter((route) => isShopRoutePath(route.path))
            .map((route) => ({...route, path: stripShopPrefix(route.path)}))
        const mainSiteRoute = shopRoutes.find((route) => route.path === SHOP_MAIN_SITE_ROUTE)

        // Разделы основного сайта (/clinics/, /blog/ …) иначе совпали бы с разделом витрины и отдали 404.
        const sections = mainSiteRoute
            ? mainSiteSections(routes.filter((route) => !isShopRoutePath(route.path)).map((route) => route.path))
                .map((section) => ({...mainSiteRoute, name: `shop-main-site-${section}`, path: `/${section}${SHOP_MAIN_SITE_ROUTE}`}))
            : []

        return [...shopRoutes, ...sections]
    },
}
